export enum DiceRollRaidGameResultType {
    COMPENSATION_WIN = "COMPENSATION_WIN",
    FULL_WIN = "FULL_WIN",
}
